<fs-dialog>
  <div mat-dialog-title>Switch Organization</div>
  <mat-dialog-content>
    <div class="fs-column" class="environment-items">
      <div class="environment-item" *ngFor="let environment of environments" (click)="switch(environment)">
        <div class="fs-row.gap-sm">
          <fs-badge shape="circle" [size]="45" image="{{ environment.image.small }}"></fs-badge>
          <div>{{ environment.name }}</div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="null" type="button">Done</button>
  </mat-dialog-actions>
</fs-dialog>
